import { render, staticRenderFns } from "./liveBroad.vue?vue&type=template&id=0ef74af8&"
import script from "./liveBroad.vue?vue&type=script&lang=js&"
export * from "./liveBroad.vue?vue&type=script&lang=js&"
import style0 from "./liveBroad.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports